// @flow
export const CityOptions = [
  {
      "text": "Adana",
      "value": "Adana"
  },
  {
      "text": "Adıyaman",
      "value": "Adıyaman"
  },
  {
      "text": "Afyonkarahisar",
      "value": "Afyonkarahisar"
  },
  {
      "text": "Ağrı",
      "value": "Ağrı"
  },
  {
      "text": "Aksaray",
      "value": "Aksaray"
  },
  {
      "text": "Amasya",
      "value": "Amasya"
  },
  {
      "text": "Ankara",
      "value": "Ankara"
  },
  {
      "text": "Antalya",
      "value": "Antalya"
  },
  {
      "text": "Ardahan",
      "value": "Ardahan"
  },
  {
      "text": "Artvin",
      "value": "Artvin"
  },
  {
      "text": "Aydın",
      "value": "Aydın"
  },
  {
      "text": "Balıkesir",
      "value": "Balıkesir"
  },
  {
      "text": "Bartın",
      "value": "Bartın"
  },
  {
      "text": "Batman",
      "value": "Batman"
  },
  {
      "text": "Bayburt",
      "value": "Bayburt"
  },
  {
      "text": "Bilecik",
      "value": "Bilecik"
  },
  {
      "text": "Bingöl",
      "value": "Bingöl"
  },
  {
      "text": "Bitlis",
      "value": "Bitlis"
  },
  {
      "text": "Bolu",
      "value": "Bolu"
  },
  {
      "text": "Burdur",
      "value": "Burdur"
  },
  {
      "text": "Bursa",
      "value": "Bursa"
  },
  {
      "text": "Çanakkale",
      "value": "Çanakkale"
  },
  {
      "text": "Çankırı",
      "value": "Çankırı"
  },
  {
      "text": "Çorum",
      "value": "Çorum"
  },
  {
      "text": "Denizli",
      "value": "Denizli"
  },
  {
      "text": "Diyarbakır",
      "value": "Diyarbakır"
  },
  {
      "text": "Düzce",
      "value": "Düzce"
  },
  {
      "text": "Edirne",
      "value": "Edirne"
  },
  {
      "text": "Elazığ",
      "value": "Elazığ"
  },
  {
      "text": "Erzincan",
      "value": "Erzincan"
  },
  {
      "text": "Erzurum",
      "value": "Erzurum"
  },
  {
      "text": "Eskişehir",
      "value": "Eskişehir"
  },
  {
      "text": "Gaziantep",
      "value": "Gaziantep"
  },
  {
      "text": "Giresun",
      "value": "Giresun"
  },
  {
      "text": "Gümüşhane",
      "value": "Gümüşhane"
  },
  {
      "text": "Hakkari",
      "value": "Hakkari"
  },
  {
      "text": "Hatay",
      "value": "Hatay"
  },
  {
      "text": "Iğdır",
      "value": "Iğdır"
  },
  {
      "text": "Isparta",
      "value": "Isparta"
  },
  {
      "text": "İstanbul",
      "value": "İstanbul"
  },
  {
      "text": "İzmir",
      "value": "İzmir"
  },
  {
      "text": "Kahramanmaraş",
      "value": "Kahramanmaraş"
  },
  {
      "text": "Karabük",
      "value": "Karabük"
  },
  {
      "text": "Karaman",
      "value": "Karaman"
  },
  {
      "text": "Kars",
      "value": "Kars"
  },
  {
      "text": "Kastamonu",
      "value": "Kastamonu"
  },
  {
      "text": "Kayseri",
      "value": "Kayseri"
  },
  {
      "text": "Kırıkkale",
      "value": "Kırıkkale"
  },
  {
      "text": "Kırklareli",
      "value": "Kırklareli"
  },
  {
      "text": "Kırşehir",
      "value": "Kırşehir"
  },
  {
      "text": "Kilis",
      "value": "Kilis"
  },
  {
      "text": "Kocaeli",
      "value": "Kocaeli"
  },
  {
      "text": "Konya",
      "value": "Konya"
  },
  {
      "text": "Kütahya",
      "value": "Kütahya"
  },
  {
      "text": "Malatya",
      "value": "Malatya"
  },
  {
      "text": "Manisa",
      "value": "Manisa"
  },
  {
      "text": "Mardin",
      "value": "Mardin"
  },
  {
      "text": "Mersin",
      "value": "Mersin"
  },
  {
      "text": "Muğla",
      "value": "Muğla"
  },
  {
      "text": "Muş",
      "value": "Muş"
  },
  {
      "text": "Nevşehir",
      "value": "Nevşehir"
  },
  {
      "text": "Niğde",
      "value": "Niğde"
  },
  {
      "text": "Ordu",
      "value": "Ordu"
  },
  {
      "text": "Osmaniye",
      "value": "Osmaniye"
  },
  {
      "text": "Rize",
      "value": "Rize"
  },
  {
      "text": "Sakarya",
      "value": "Sakarya"
  },
  {
      "text": "Samsun",
      "value": "Samsun"
  },
  {
      "text": "Siirt",
      "value": "Siirt"
  },
  {
      "text": "Sinop",
      "value": "Sinop"
  },
  {
      "text": "Sivas",
      "value": "Sivas"
  },
  {
      "text": "Şanlıurfa",
      "value": "Şanlıurfa"
  },
  {
      "text": "Şırnak",
      "value": "Şırnak"
  },
  {
      "text": "Tekirdağ",
      "value": "Tekirdağ"
  },
  {
      "text": "Tokat",
      "value": "Tokat"
  },
  {
      "text": "Trabzon",
      "value": "Trabzon"
  },
  {
      "text": "Tunceli",
      "value": "Tunceli"
  },
  {
      "text": "Uşak",
      "value": "Uşak"
  },
  {
      "text": "Van",
      "value": "Van"
  },
  {
      "text": "Yalova",
      "value": "Yalova"
  },
  {
      "text": "Yozgat",
      "value": "Yozgat"
  },
  {
      "text": "Zonguldak",
      "value": "Zonguldak"
  }
];



// WEBPACK FOOTER //
// ./src/Constants/GlobalVariables/CityOptions.js